import { render, staticRenderFns } from "./detailForumLogs.vue?vue&type=template&id=06283260&"
import script from "./detailForumLogs.vue?vue&type=script&lang=js&"
export * from "./detailForumLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports